import { render, staticRenderFns } from "./JieshaoDetail.vue?vue&type=template&id=b7a305c6&scoped=true"
import script from "./JieshaoDetail.vue?vue&type=script&lang=js"
export * from "./JieshaoDetail.vue?vue&type=script&lang=js"
import style0 from "./JieshaoDetail.vue?vue&type=style&index=0&id=b7a305c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a305c6",
  null
  
)

export default component.exports